import React from 'react'
import { FetcherList } from '@garpix/fetcher/fetcher-list/react-router'
import { dataStates } from '@garpix/fetcher'
import { useConfig } from '@/hooks'
import Title from '@/components/Title'
import style from '../styles/games.module.scss'
import BigCard from './BigCard'
import SmallCard from './SmallCard'
import { api } from '@/api'
import { IGameList } from '@/interfaces/Game'
import BlockSpinner from '@/components/Spinner/BlockSpinner'
import Section from '@/components/Section'

const GamesList = (): React.ReactElement => {
  const config = useConfig()
  const detailGame: string = config.detail_game

  return (
    <Section>
      <Title type='h2' hidden>
        Игры
      </Title>
      <FetcherList isScrollTop={false} isHistoryPush={false} api={api.getGames}>
        {({ results, status }: { results: IGameList[], status: string }) => {
          if (status === dataStates.loading) {
            return <BlockSpinner />
          }
          const firstGame = results[0]
          const allGames = results.slice(1)
          return (
            <>
              {firstGame !== undefined
                ? (
                  <BigCard
                    title={firstGame.name}
                    description={firstGame.preview_text}
                    newGame={firstGame.property_new_value === '1'}
                    url={`${detailGame}?element_id=${firstGame.id}`}
                    video={firstGame?.property_trailer_value?.[0]}
                    preview={firstGame?.preview_picture?.[0] ?? ''}
                  />
                  )
                : null}
              {allGames.length > 0
                ? (
                  <div className={style.games_grid}>
                    {allGames.map((el) => {
                      return (
                        <SmallCard
                          key={el.id}
                          title={el.name}
                          description={el.preview_text}
                          url={`${detailGame}?element_id=${el.id}`}
                          preview={el.preview_picture?.[0] ?? ''}
                        />
                      )
                    })}
                  </div>
                  )
                : undefined}
            </>
          )
        }}
      </FetcherList>
    </Section>
  )
}

export default GamesList
